import NoteIcon from '@atlaskit/icon/core/note';
import React from 'react';

export const SvgCanvas = () => (
  <NoteIcon label="" testId="ads-refreshed-icon" />
);
